import React, { Component } from 'react';
import { I18n } from 'common/i18n';
import { ForgeButton } from '@tylertech/forge-react';
import { isMobileOrTablet } from 'common/visualizations/helpers/MediaQueryHelper';

export default class StoryEditButton extends Component {
  render() {
    const scope = 'shared.components.asset_action_bar.publication_action';
    const label = I18n.t('published.primary_action_text', { scope });
    const onClick = () => (location.href = window.STORY_EDIT_URL || '/');

    if (isMobileOrTablet()) {
      return (
        <button onClick={onClick} data-testid="story-edit-button" className="mobile-action-item">
          {label}
        </button>
      );
    }

    return (
      <ForgeButton
        onClick={onClick}
        variant="outlined"
        data-testid="story-edit-button"
        className="edit-button"
      >
        {label}
      </ForgeButton>
    );
  }
}
